import {Injectable} from '@angular/core';

// tslint:disable-next-line:variable-name
const __window = (): any => {
  // return the global native browser window object
  return window;
};


// tslint:disable-next-line:variable-name
const __document = (): any => {
  // return the global native browser document object
  return document;
};


// tslint:disable-next-line:variable-name
const __screen = (): any => {
  // return the global native browser screen object
  return screen;
};

// tslint:disable-next-line:variable-name
const __geoip2 = (): any => {
  // return the global native  geoip2 object
  // @ts-ignore
  return geoip2;
};



@Injectable({
  providedIn: 'root'
})
export class WindowRefService {

  constructor() {
  }

  get nativeDocument(): any {
    return __document();
  }

  get nativeWindow(): any {
    return __window();
  }

  get nativeScreen(): any {
    return __screen();
  }

  get nativeGeoIp(): any {
    return __geoip2();
  }

  get href(): string {
    return this.nativeWindow.location.href;
  }

  get ancestorOrigins(): string[] {
    return this.nativeWindow.ancestorOrigins || [];
  }

  get host(): string {
    return `${this.nativeWindow.location.protocol}//${this.nativeWindow.location.host}`;
  }

  get queryParams(): URLSearchParams {
    const url: URL = new URL(this.nativeWindow.location);
    // const params: URLSearchParams = url.searchParams;
    return url.searchParams;
  }

  getQueryParams(urlStr: string): URLSearchParams | null {
    if (urlStr) {
      const url: URL = new URL(urlStr);
      return url.searchParams;
    }
    return null;
  }

  get queryString(): string {
    return this.nativeWindow.location.search.slice(1);
  }


  navigate(url: string, target: string = '_blank'): void {
    if (url && this.nativeDocument) {
      try {
        const link = this.nativeDocument.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('target', target);
        link.click();
      } catch (e) {
        console.error({url, e});
        this.nativeWindow.open(url, target);
      }
    }
  }

  getLocalData(key: string): any {
    if (localStorage) {
      const v: string | null = localStorage.getItem(key);
      return (v) ? JSON.parse(v) : null;
    }
    return null;
  }

  checkLocalStorage(key: string): boolean {
    return !!localStorage.getItem(key);
  }

  setLocalData(key: string, v: any): void {
    if (localStorage && v && key) {
      const s: string = JSON.stringify(v);
      // tslint:disable-next-line:no-unused-expression
      // localStorage.getItem(key) && localStorage.removeItem(key);
      localStorage.setItem(key, s);
    }
  }

  removeLocalData(key: string): void {
    if (localStorage && key) {
      // tslint:disable-next-line:no-unused-expression
      localStorage.getItem(key) && localStorage.removeItem(key);
    }
  }


  getSessionData(key: string): any {
    if (sessionStorage) {
      const v: string | null = sessionStorage.getItem(key);
      return (v) ? JSON.parse(v) : null;
    }
    return null;
  }

  checkSessionStorage(key: string): boolean {
    return !!sessionStorage.getItem(key);
  }

  setSessionData(key: string, v: any): void {
    if (sessionStorage && v && key) {
      const s: string = JSON.stringify(v);
      // tslint:disable-next-line:no-unused-expression
      // localStorage.getItem(key) && localStorage.removeItem(key);
      sessionStorage.setItem(key, s);
    }
  }

  removeSessionData(key: string): void {
    if (sessionStorage && key) {
      // tslint:disable-next-line:no-unused-expression
      sessionStorage.getItem(key) && sessionStorage.removeItem(key);
    }
  }

  cleanLocalData(email: string): void {
    if (localStorage && email) {
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i) || '';
        if (key.indexOf(email) > -1) {
          this.removeLocalData(key);
        }
      }
    }
  }

  cleanSessionData(): void {
    if (sessionStorage) {
      sessionStorage.clear();
    }
  }

  reloadLocation(part?: string, delay: number = 0): void {
    setTimeout(() => {
      this.nativeWindow.location.href = (!part) ? this.host : `${this.host}/${part}`;
    }, delay);
  }

  public reportGtagEventNew(eventName?: string | null,  eventValues?: any | null): void {
    if (this.nativeWindow && this.nativeWindow.gtag && eventName) {
      console.log('reportGtagEventNew', eventName, eventValues);
      this.nativeWindow.gtag('event', eventName, eventValues);
    }
  }

  public reportMetaEvent(eventName?: string | null,  eventValues?: any | null): void {
    if (this.nativeWindow && this.nativeWindow.fbq && eventName) {
      console.log('reportMetaEvent', eventName, eventValues);
      // trackSingle: only our pixel (init in adcore-prime index.html), not the other pixels that GTM / HubSpot init.
      this.nativeWindow.fbq('trackSingle', '775859870275129', eventName, eventValues);
    }
  }

}
